<template>
  <ion-page id="signoff-page">
    <ion-content>
      <TopLine :style="styleTopline" :title="recognizerDemoTitle" :microphoneIsMuted="microphoneIsMuted" @topline-click="toplineClick"/>

      <div :style="styleRecognizerResult" >
        <div class="myheadingComment">
          {{ translatePhrase("Say the words from ' play the computer '") }}.<br>
        </div>
        <div class="myheading">

           <ion-grid>
           <ion-row class="bottomRow">
            <ion-col size="2" class="ion-text-wrap myHeadingLabel">
            <ion-label>
              {{ translateEnglishWords("Heard") }} :
              </ion-label>
            </ion-col>
            <ion-col size="10" class="ion-text-wrap">
              <ion-label>
              {{ wordsSaidDisplay }}
              </ion-label>
            </ion-col>
          </ion-row>
          </ion-grid>
        </div>
      </div>
      <div :style="styleRecognizerWords" class="myText">
        <ion-grid>

        <div v-for="item in screenItems" v-bind:key="item.label">
    
   
          <ion-row class="bottomRow">
            <ion-col size="2" class="ion-text-wrap myLabel">
            <ion-label>
              {{ item.label }} :
              </ion-label>
            </ion-col>
            <ion-col size="10" class="ion-text-wrap">
              <ion-label>
              {{  item.words }}
              </ion-label>
            </ion-col>
          </ion-row>
          </div>
        </ion-grid>
     
        
      </div>
      <ToolBar :style="styleToolbar" :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
    </ion-content>
  </ion-page>
</template>

<script setup>

  import { IonLabel,IonItem,IonPage, IonContent, IonGrid, IonRow, IonCol } from '@ionic/vue';
  import { computed } from "@vue/reactivity"

  import { ref, watch } from 'vue';
  import { useConnectionStore } from '../../stores/connectionStore';
  import { useWindowSizeStore } from '../../stores/windowSizeStore';
  import { doStartupCheck } from '../../composables/startupCheck.js'
  import TopLine from '@/components/TopLine.vue'

  import { buildStyleToolbar, buildStyleTopline,buildStyleMiddle,availableWidthHeight,
                middleRect } from '@/composables/screenSize'

  import ToolBar from '@/components/ToolBar.vue'
  import { translateEnglishWords , translatePhrase } from '@/composables/translation';

  const emit = defineEmits(['where-next','word-list','mic-is-muted'])

  const props = defineProps({
      wordsSaid : {
        type : String,
        default : ""
      },
      wordsSaidTrigger : {
        type : Number,
        default : 0
      }
    })

  const wordsSaid = computed({get() {return props.wordsSaid}})
  const wordsSaidTrigger = computed({get() {return props.wordsSaidTrigger}})

  const wordsSaidDisplay = ref("")

  const connectionStore = useConnectionStore()
  const languageInUse = connectionStore.getLanguageInUse

  const isDark = ref(connectionStore.getDarkmode != "light")

  const recognizerDemoTitle = ref(translateEnglishWords("Recognizer Practice"))

  var natoWords = "alfa bravo charlie delta echo fox foxtrot golf hotel"

  // French doesn't have foxtrot so don't let user see it
  if (languageInUse == "fr")
    natoWords = natoWords.replace("foxtrot ","")

  const screenItems = ref([
    { label : translateEnglishWords("Piece"), words : translateEnglishWords("rook bishop knight king queen pawn")},
    { label : translateEnglishWords("Rank"), words : translateEnglishWords("one two three four five six seven eight")},
    { label : translateEnglishWords("File Letter"), words : translateEnglishWords("a b c d e f g h")},
    { label : translateEnglishWords("File Word"), words : translateEnglishWords(natoWords)},
    { label : translateEnglishWords("File Word"), words : translateEnglishWords("anna bella cesar david eva felix gustav hector")},
    { label : translateEnglishWords("Describe"), words : translateEnglishWords("describe black white rank file square locate")},
    { label : translateEnglishWords("Play"), words : translateEnglishWords("play ignore at takes capture captures castle side short long")},
    { label : translateEnglishWords("Command"), words : translateEnglishWords("command explain start game end new option options take back review replay reveal revert done repeat listen mute")},
  ])
  
  const wordlist = "command explain start game end new option options take back review replay reveal revert done repeat listen mute describe play ignore at move takes capture captures castle side short long rook bishop knight king queen pawn alfa bravo charlie delta echo fox foxtrot golf hotel anna bella cesar david eva felix gustav hector a b c d e f g h one two three four five six seven eight black white rank file square locate"
  emit("word-list",wordlist)

  const wordlistTrigger = ref(0)

  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })

  const toolbarElements = [
  ]
  const toolbarTrigger = ref(0)

  const styleToolbar = ref(buildStyleToolbar(availableWidthHeight()))
  const styleTopline = ref(buildStyleTopline(availableWidthHeight()))
  const styleRecognizerResult = ref(buildStyleMiddle(availableWidthHeight()))
  const styleRecognizerWords = ref(buildStyleMiddle(availableWidthHeight()))
  updateWidthHeights()

  const microphoneIsMuted = ref(connectionStore.getMicrophoneIsMuted)
  emit("mic-is-muted",microphoneIsMuted.value)

   watch(wordsSaidTrigger, (newVal,oldVal) => {
     //console.log('*********** words said ',props.wordsSaid)
     generateWordsDisplay(props.wordsSaid)
     processWords(props.wordsSaid)

   })

  watch(() => windowSizeStore.getWindowSize, () => {
    updateWidthHeights()
  })

   function updateWidthHeights() {

    const heightOfResult = 50
    const availableSpace = availableWidthHeight()

    styleToolbar.value = buildStyleToolbar(availableSpace)
    styleTopline.value = buildStyleTopline(availableSpace)
    styleRecognizerResult.value = buildStyleMiddle(availableWidthHeight())
    styleRecognizerWords.value = buildStyleMiddle(availableWidthHeight())

    const rect = middleRect(availableWidthHeight())

    styleRecognizerResult.value.height = heightOfResult + "px"
    const wordsTop = rect.top + heightOfResult
    const wordsHeight = rect.height - heightOfResult
    styleRecognizerWords.value.top =  wordsTop + "px"
    styleRecognizerWords.value.height = wordsHeight + "px"
  }

  function generateWordsDisplay(text) {
    wordsSaidDisplay.value = text
  }

   function toplineClick(whatClicked) {
    console.log("topline",whatClicked)
    switch (whatClicked) {
      case "done" :
        processWords("command done")
        break;
      case "microphone" :
        microphoneIsMuted.value = !microphoneIsMuted.value 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        break

    }
  }
  
  function toolbarClick(arrayIndex) {
  }

  // recognizer sends the native language after a comma for this routine
  function processWords(text) {
    console.log("text in recognizer ",text)
    const splitResults = text.split(",")
    wordsSaidDisplay.value = (splitResults.length > 1) ? splitResults[1].replace("[unk]","?") : ""
    const returnArray = parseWordsSaid(splitResults[0])
    //console.log("command found",returnArray)

    switch (returnArray[0]) {
      case "mute" :
        microphoneIsMuted.value = true 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(true)
        break
      case "listen" :
        microphoneIsMuted.value = false 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(false)
        break
      case "done" :
        emit("where-next","/voicesmenu")
        break;
    }
  }

  function parseCommands(words,currentWordIndex) {
    
    //console.log("in parse commands",words,currentWordIndex)
    var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
    var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
    var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

    for (var i = 0; i < words.length; i++) {
        if (currentWord == "ignore") {
            return ["ignore",""];
        }
        if (currentWord == "done" || currentWord == "mute" || currentWord == "listen") {
            return [currentWord,""]
        }
        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
    }
    return ["ignore",""];
  }

  function parseWordsSaid(str) {
  
    const words = str.split(" ")

    //console.log("string ",str)
    //console.log("words",words,words.length)
    if (words.length == 0) {
        return ["ignore",""];
    }

    var currentWord = (words.length > 0) ? words[0] : "xyz"
    var nextWord = (words.length > 1) ? words[1] : "xyz"
    var nextNextWord = (words.length > 2) ? words[2] : "xyz"
          
    //console.log("current word",currentWord)

    for (var i = 0; i < words.length; i++) {
        if (currentWord == "ignore") {
            return ["ignore",""];
        }

        if (currentWord == "command") {
          const returnArray = parseCommands(words, i+1)
          return returnArray
        }
        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
    }
    return ["ignore",""]
  }

</script>

<style scoped>

.myLabel {
  font-style: italic;
  opacity: 80%;
  text-align: right;
}

.bottomRow {
  margin-top: -8px;
}

.italics {
  font-style: italic;
}

.myHeadingLabel {
  font-style: italic;
  text-align: right;
}

.myheading {
  background: #4c6ca0;
  color : white;
  font-style: italic;
 
}

.myheadingComment {
  background: #4c6ca0;
  color : white;
  padding-left: 5px;
  padding-bottom: 0px;
}
</style>